import { useEffect, useState } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Typography from '@mui/material/Typography';
import CircularLoader from 'components/UI/Loaders/CircularLoader';
import { PTZ_REQUEST } from 'components/transaction/components/panels/transaction/cameras/cameraStream/PTZ/config';
import styles from './PTZRequestStatus.module.css';
import { Tooltip } from '@mui/material';

const FADE_OUT_DURATION_MS = 500;

function PTZRequstStatus({ ptzRequestStatus }) {
    const [isVisible, setIsVisible] = useState(true);
    const [isFading, setIsFading] = useState(false);

    useEffect(() => {
        const isResultStatus = ptzRequestStatus.status === PTZ_REQUEST.STATUS.SUCCESS || ptzRequestStatus.status === PTZ_REQUEST.STATUS.ERROR;

        if (isResultStatus) {
            setIsVisible(true);
            setIsFading(false);

            const fadeTimer = setTimeout(() => {
                setIsFading(true);
            }, FADE_OUT_DURATION_MS);

            const hideTimer = setTimeout(() => {
                setIsVisible(false);
            }, FADE_OUT_DURATION_MS * 3);

            return () => {
                clearTimeout(fadeTimer);
                clearTimeout(hideTimer);
            };
        } else {
            setIsVisible(true);
            setIsFading(false);
        }
    }, [ptzRequestStatus.status]);

    if (ptzRequestStatus.status === PTZ_REQUEST.STATUS.IN_PROGRESS) {
        return (
            <>
                <CircularLoader
                    containerStyles={{ position: 'relative', width: '20px', height: '20px' }}
                    spinnerOptions={{ size: 20, sx: { color: 'white', p: 0, m: 0, mr: '5px' } }}
                />
                <Tooltip
                    title={ptzRequestStatus.tooltipMessage}
                    disableHoverListener={!ptzRequestStatus.tooltipMessage}
                    sx={{ display: 'flex', alignItems: 'center' }}
                >
                    <p>{ptzRequestStatus.message}</p>
                </Tooltip>
            </>
        );
    }

    if (ptzRequestStatus.status === PTZ_REQUEST.STATUS.SUCCESS && isVisible) {
        return (
            <div className={`${styles.statusContainer} ${isFading ? styles.fading : ''}`}>
                <CheckCircleIcon sx={{ fontSize: 24, color: '#66BB6A' }} />
                <Typography sx={{ fontSize: '10px', fontWeight: 500, lineHeight: '14px', whiteSpace: 'nowrap', color: '#66BB6A' }}>
                    Success
                </Typography>
            </div>
        );
    }

    if (ptzRequestStatus.status === PTZ_REQUEST.STATUS.ERROR && isVisible) {
        return (
            <div className={`${styles.statusContainer} ${isFading ? styles.fading : ''}`}>
                <CancelIcon sx={{ fontSize: 24, color: '#F44336' }} />
                <Typography sx={{ fontSize: '10px', fontWeight: 500, lineHeight: '14px', whiteSpace: 'nowrap', color: '#F44336' }}>
                    Please try again
                </Typography>
            </div>
        );
    }

    return null;
}

export default PTZRequstStatus;
